import { useEffect, useState } from 'react'

// Owner toggles the AI debug panel from Settings. Stored in
// localStorage rather than the DB because it's a UI preference, not
// per-device state worth syncing, and works offline. Cross-tab sync
// is free via the `storage` event so flipping the switch on one tab
// updates other tabs immediately.
const KEY = 'phoenix.aiDebugEnabled'

function read() {
  if (typeof window === 'undefined') return false
  return window.localStorage.getItem(KEY) === '1'
}

export function useAiDebugEnabled() {
  const [enabled, setEnabledState] = useState(read)

  useEffect(() => {
    if (typeof window === 'undefined') return undefined
    const onStorage = (e) => {
      if (e.key === KEY) setEnabledState(e.newValue === '1')
    }
    window.addEventListener('storage', onStorage)
    return () => window.removeEventListener('storage', onStorage)
  }, [])

  const setEnabled = (next) => {
    if (typeof window === 'undefined') return
    if (next) window.localStorage.setItem(KEY, '1')
    else window.localStorage.removeItem(KEY)
    setEnabledState(!!next)
  }

  return [enabled, setEnabled]
}
